if(!customElements.get('more-or-less-details')) {
    class MoreOrLessDetails extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.addEventListener('click', event => {
                event.preventDefault();
                if(event.target.closest('.read-more')) {
                    this.classList.add('read-more');
                }
                if(event.target.closest('.read-less')) {
                    this.classList.remove('read-more');
                }
            })
        }
    }
    customElements.define('more-or-less-details', MoreOrLessDetails);
}